import React from "react";
import { formatCurrency } from "../../../lib/utils/formatters";
import {
  linkedAccountSummary,
  retainedCreditLimit,
} from "../../../lib/utils/post_approval_plaid_result";
import {
  creditLimitChange,
  virtualCardEntitlement,
} from "../../../lib/utils/post_approval_plaid_uplift";
import MobileAppDownload from "../../shared/MobileAppDownload";
import ReturnToMerchant from "../../shared/ReturnToMerchant";
import {
  ApprovalBadge,
  ApprovalCard,
  ApprovalCopy,
  ApprovalHeading,
  ApprovalSupport,
  LinkedBank,
} from "./PostApprovalPresentation";

// Presented by the existing finish route, after its normal completion handling.
export default function PostApprovalPlaidApproved({
  attempt,
  company,
  merchant,
  connectedMerchant,
}) {
  const uplifted = attempt.get("status") === "uplifted";
  const creditLimit = uplifted
    ? creditLimitChange(attempt).effective
    : retainedCreditLimit({ attempt, company });
  const account = linkedAccountSummary({ attempt });
  const card = virtualCardEntitlement({ company });
  return (
    <ApprovalCard
      className={
        uplifted
          ? "post-approval-positive"
          : attempt.get("status") === "no_change"
          ? "post-approval-unchanged"
          : "post-approval-retained"
      }
    >
      <ApprovalBadge />
      <ApprovalHeading creditLimit={creditLimit} />
      {uplifted ? (
        <>
          <p>
            Based on your linked bank account, you’ve unlocked additional
            benefits!
          </p>
          {card.active && card.subLimit !== null && (
            <p>
              You’ve unlocked {formatCurrency(card.subLimit)} to spend on your
              Credit Key Card.
            </p>
          )}
          {!card.active && card.eligible && (
            <p>Your account is eligible for a Credit Key virtual card.</p>
          )}
        </>
      ) : (
        <ApprovalCopy />
      )}
      <LinkedBank account={account} />
      {attempt.get("status") === "no_change" && account && (
        <p className="post-approval-note">
          Your bank account is linked. You can continue with your current
          approval.
        </p>
      )}
      {connectedMerchant && (
        <p>
          Thanks for connecting your Credit Key account to{" "}
          {connectedMerchant.name}. You are now able to make purchases and
          payments to this merchant!
        </p>
      )}
      <ReturnToMerchant merchant={merchant} asButton />
      <MobileAppDownload />
      <ApprovalSupport />
    </ApprovalCard>
  );
}
